import React from 'react';
import Modal from '../../../ui/Modal';

const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

function StatusBadge({ name }) {
  const n = String(name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен|доставлен|закрыт|завершен/.test(n)) tone = 'success';
  else if (/отмен|возврат|отклон/.test(n))     tone = 'danger';
  else if (/в пути|производ|собира/.test(n))   tone = 'info';
  return <span className={`crmpage__status crmpage__status--${tone}`}>{name || '—'}</span>;
}

const WaybillDetailsModal = ({ isOpen, onClose, orderDetails }) => {
  const list = Array.isArray(orderDetails) ? orderDetails : [];
  const total = list.reduce((sum, it) => sum + Number(it.total_amount || 0), 0);

  return (
    <Modal
      isOpen={!!isOpen}
      onClose={onClose}
      title="Заказы путевого листа"
      subtitle={`${list.length} ${list.length === 1 ? 'заказ' : 'заказов'} в путевом`}
      size="xl"
    >
      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Номер</th>
            <th>Клиент</th>
            <th>Адрес</th>
            <th>Статус</th>
            <th>Оплата</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 ? list.map((item, idx) => (
            <tr key={idx}>
              <td><span className="crmpage__num">№{item.order_number}</span></td>
              <td>{item.clname || '—'}</td>
              <td>{item.delivery_address || '—'}</td>
              <td><StatusBadge name={item.sname} /></td>
              <td><StatusBadge name={item.psname} /></td>
              <td className="num">{KZT.format(item.total_amount || 0)} ₸</td>
            </tr>
          )) : (
            <tr>
              <td colSpan={6} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>
                В путевом нет заказов
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {list.length > 0 && (
        <div className="uimodal-total">
          <span className="uimodal-total__label">Итого по путевому</span>
          <span className="uimodal-total__value">{KZT.format(total)} ₸</span>
        </div>
      )}
    </Modal>
  );
};

export default WaybillDetailsModal;
